/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminCategory
 */
export interface AdminCategory {
    /**
     * 
     * @type {string}
     * @memberof AdminCategory
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCategory
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof AdminCategory
     */
    name: string;
}

export function AdminCategoryFromJSON(json: any): AdminCategory {
    return AdminCategoryFromJSONTyped(json, false);
}

export function AdminCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'id': json['id'],
        'name': json['name'],
    };
}

export function AdminCategoryToJSON(value?: AdminCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'id': value.id,
        'name': value.name,
    };
}

